module.exports = __webpack_public_path__ + "static/img/icon04.7a759976.png";